export const GLOBAL_EXECUTION_TABS = {
	EXTRAS: 'extras',
	REGULAR: 'regular',
	SCRAPERS: 'scrapers',
	BATCHES: "batches"
}